
import GetAusstattungProduktObj from "../AusstattungProduktService";
import getRauchmelder from "./AddRauchmerlder"
import getBewegungsmelder from "./AddBewegungsmelder"
import getSteckdosen from "./AddSteckdosen"
import getSteckdosenAufputz from "./AddSteckdosenAufputz"
import getSteckdosenUsb from "./AddSteckdosenUsb"
// import getSteckdosenRahmen from "./AddSteckdosenRahmen"
import getTelefonDatenanschluss from "./AddTelefonDatenanschluss"
import getTelefonanschluss from "./AddTelefonanschluss"
import getRadioDatenSat from "./AddRadioDatenSat"
import getRadioDatenKabel from "./AddRadioDatenKabel"
// import getAnschlussdosenRahmen from "./AddAnschlussdosenRahmen"
import getTuerkommunikation from "./AddTuerkommunikation"
// import getHeizungRaum from "./AddHeizungRaum"
import getTaster from "./AddTaster"
import getAktoren from "../knx_ausstattung/AddAktoren";
import getSound from "./AddSound";
import getAudio from "./AddAudio";
import getDosenRahmen from "../home_ausstattung/AddDosenRahmen";

export default function GenerateProjectService(projectIn, productList, lang){

    let generatedProject = {
        code: null,
        name: projectIn.name,
        selectedAlternatives: (projectIn.selectedAlternatives !== undefined) ? projectIn.selectedAlternatives : {},
        floors: []
    };
    let generated_combinations = {
        name: projectIn.name,
        combinations: [],
        items: []
    };
    let systemProductList = [];
    let addSpannung = false;
    let actionsList = [];
    projectIn.floors.forEach( floorIn => {
        const floor = {
            id: floorIn.id,
            name: floorIn.name,
            type: floorIn.typePro,
            rooms: []
        };
        const floor_comb = {
            name: floorIn.name,
            combinations: [],
            subStructure: []
        };
        floorIn.rooms.forEach(roomIn => {
            const room = {
                id: roomIn.id,
                name: roomIn.name,
                type: roomIn.typePro,
                products: [],
                actions: []
            }
            let combinations = {
                name: room.name,
                combinations: [],
                type: roomIn.typePro,
                products: []
            };
            let schaltbare = []; let normal = []; let daten = {telefon:[],radio:[]}; let charger = [];
            const austattung_produkt = GetAusstattungProduktObj(projectIn, roomIn, lang);
            let productListInner = []; let optionalRahmen = [];

            //todo use algorithm to fill productListInner and systemProductList
            productListInner = productListInner.concat(getRauchmelder(roomIn, austattung_produkt));
            productListInner = productListInner.concat(getBewegungsmelder(roomIn, austattung_produkt));

            const steckdosen = getSteckdosen(roomIn, austattung_produkt);
            productListInner = productListInner.concat(steckdosen.productList);
            if (steckdosen.schaltbare.length) { schaltbare = schaltbare.concat(steckdosen.schaltbare); }
            if (steckdosen.normal.length) { normal = normal.concat(steckdosen.normal); }

            const steckdosen_aufputz = getSteckdosenAufputz(roomIn, austattung_produkt);
            productListInner = productListInner.concat(steckdosen_aufputz.productList);
            if (steckdosen_aufputz.schaltbare.length) { schaltbare = schaltbare.concat(steckdosen_aufputz.schaltbare); }
            if (steckdosen_aufputz.normal.length) { normal = normal.concat(steckdosen_aufputz.normal); }

            const steckdosen_usb = getSteckdosenUsb(roomIn, austattung_produkt);
            productListInner = productListInner.concat(steckdosen_usb.productList);
            productListInner = productListInner.concat(steckdosen_usb.chargerProductList);
            if (steckdosen_usb.schaltbare.length) { schaltbare = schaltbare.concat(steckdosen_usb.schaltbare); }
            if (steckdosen_usb.normal.length) { normal = normal.concat(steckdosen_usb.normal); }
            if (steckdosen_usb.charger.length) { charger = charger.concat(steckdosen_usb.charger); }

            const daten_anschluss = getTelefonDatenanschluss(roomIn, austattung_produkt);
            productListInner = productListInner.concat(daten_anschluss.productList);
            for(let k=0; k < daten_anschluss.cProducts.length; k++) {
                daten.telefon.push(daten_anschluss.cProducts[k]);
            }

            const telefon_anschluss = getTelefonanschluss(roomIn, austattung_produkt);
            productListInner = productListInner.concat(telefon_anschluss.productList);
            for(let k=0; k < telefon_anschluss.cProducts.length; k++) {
                daten.telefon.push(telefon_anschluss.cProducts[k]);
            }

            const sat_anschluss = getRadioDatenSat(roomIn, austattung_produkt);
            productListInner = productListInner.concat(sat_anschluss.productList);
            for(let k=0; k < sat_anschluss.cProducts.length; k++) {
                daten.radio.push(sat_anschluss.cProducts[k]);
            }

            const kabel_anschluss = getRadioDatenKabel(roomIn, austattung_produkt);
            productListInner = productListInner.concat(kabel_anschluss.productList);
            for(let k=0; k < kabel_anschluss.cProducts.length; k++) {
                daten.radio.push(kabel_anschluss.cProducts[k]);
            }

            const rahmen = getDosenRahmen(roomIn, austattung_produkt, {schaltbare, normal, daten, charger}, projectIn.subProjectType === 'umbau');
            productListInner = productListInner.concat(rahmen.productList);
            productListInner = productListInner.concat(rahmen.chargerFrames);
            if (projectIn.subProjectType === 'umbau') {
                optionalRahmen = optionalRahmen.concat(rahmen.productList_optional);
                rahmen.productList_optional.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count}); });
            }
            rahmen.combinations.forEach(comb => combinations.combinations.push(comb));

            const audio = getAudio(roomIn, austattung_produkt);
            productListInner = productListInner.concat(audio.productList);
            audio.productList.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count}); });

            const taster = getTaster(roomIn, austattung_produkt, projectIn.selectedAlternatives, []);
// console.log('taster', taster,productListInner)
            if(taster.list.length > 0){
                productListInner = productListInner.concat(taster.list);
                actionsList = actionsList.concat(taster.actions);
                room.actions = room.actions.concat(taster.actions);
                taster.combinations.forEach(comb => combinations.combinations.push(comb));
                taster.additional_products.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count, origin: 'generate, 130'}); });
            }
// console.log('after taster', taster, combinations,productListInner)
            productListInner.forEach( p => {
                if (!p.product || p.product === '') { console.log('skipping empty product', p); return; }
                const productTmp = room.products.find(pi => pi.Artikelnummer.toString() === p.product.toString());
                if(productTmp === undefined){
                    const pp = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
                    if(pp === undefined){ console.log('product not found', p); return; }
                    const productToPush = {...pp, count: p.count, actions: p.actions ? p.actions: []};
                    if(p.alt !== undefined){
                        const nlist = p.alt.map(pa => {
                            const altList = [];
                            pa.products.forEach(paPro => {
                                const ppa = productList.find(pl => pl.Artikelnummer.toString() === paPro.toString());
                                if(pp === undefined){
                                    return;
                                }
                                altList.push(ppa);
                            })
                            pa.products = altList;
                            return pa;
                        });
                        productToPush.productSwitch = nlist;
                    }
                    room.products.push(productToPush);
                }else {
                    productTmp.count += p.count;
                    productTmp.actions = productTmp.actions.concat(p.actions || []);
                }
            });
            optionalRahmen.forEach( p => {
                if (!p.product || p.product === '') { console.log('skipping empty product', p); return; }
                const productTmp = room.products.find(pi => pi.Artikelnummer.toString() === p.product.toString() && p.isOptional === true);
                if(productTmp === undefined){
                    const pp = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
                    if(pp === undefined){ console.log('product not found', p); return; }
                    const productToPush = {...pp, count: p.count, actions: p.actions ? p.actions: [], isOptional: true};
                    if(p.alt !== undefined){
                        const nlist = p.alt.map(pa => {
                            const altList = [];
                            pa.products.forEach(paPro => {
                                const ppa = productList.find(pl => pl.Artikelnummer.toString() === paPro.toString());
                                if(pp === undefined){
                                    return;
                                }
                                altList.push(ppa);
                            })
                            pa.products = altList;
                            return pa;
                        });
                        productToPush.productSwitch = nlist;
                    }
                    room.products.push(productToPush);
                }else {
                    productTmp.count += p.count;
                    productTmp.actions = productTmp.actions.concat(p.actions || []);
                }
            });
            floor.rooms.push(room);
            floor_comb.subStructure.push(combinations)
        });
        generatedProject.floors.push(floor);
        generated_combinations.items.push(floor_comb);
    });
    const austattung_produkt = projectIn.floors.length && projectIn.floors[0].rooms.length ? GetAusstattungProduktObj(projectIn, projectIn.floors[0].rooms[0], lang) : [];
    //todo use algorithm to fill systemProductList
    systemProductList = [];
    const tuerko = getTuerkommunikation(projectIn, austattung_produkt);
    tuerko.productList.forEach(p => {
        if (p.product !== undefined) {
            const pz = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
            if (pz) {
                generatedProject = {
                    ...generatedProject,
                    floors: generatedProject.floors.map(floor => {
                        return {
                            ...floor,
                            rooms: floor.rooms.map(room => {
                                if (p.room.typePro === room.type && !p.assigned) {
                                    p = {...p, assigned: true};
                                    return {
                                        ...room,
                                        products: [...room.products, {...pz, count: p.count}]
                                    }
                                }
                                return room;
                            })
                        };
                    })
                };
                generated_combinations = {
                    ...generated_combinations,
                    items: generated_combinations.items.map(item => {
                        return {
                            ...item,
                            subStructure: item.subStructure.map(room => {
                                if (p.room.type === room.type && !p.assignedComb) {
                                    p = {...p, assignedComb: true};
                                    return {
                                        ...room,
                                        products: [...room.products, {artikelnummer: p.product, factor: p.count}]
                                    };
                                }
                                return room;
                            })
                        };
                    })
                };
            }
        }
    });
    // console.log('tuerko', tuerko)
    systemProductList = systemProductList.concat(getSound(projectIn, austattung_produkt));
    const akt = getAktoren(projectIn, austattung_produkt, actionsList);
    if(akt.length > 0){
        addSpannung = true;
        systemProductList = systemProductList.concat(akt);
    }
    if(addSpannung){
        systemProductList.push(
            {
                product: austattung_produkt["spannung"],
                count: 1
            }
        );
    }
    if(systemProductList.length > 0){
        const uv = {
            id: "Unterverteilung", //uuidv4(), todo
            name: "Unterverteilung",
            type: "cc245399-46d7-42fc-a576-0d11ecf0db71",
            products: [],
            installationLocations: [{
                id: "InstallationLocation",
                name: "[Unterverteiler]",
                type: "4e6ab71c-beee-4f8b-9c77-1bc98394d104",
                isSubdistribution: true,
                products: [],
                actions: []
            }]
        }
        let combinations_uv = {
            name: "Unterverteilung",
            type: "cc245399-46d7-42fc-a576-0d11ecf0db71",
            combinations: [],
            products: []
        };
        const uvProducts = [];
        systemProductList.forEach( p => {
            combinations_uv.products.push({artikelnummer: p.product.toString(), factor: p.count});
            const productTmp = uvProducts.find(pi => pi.Artikelnummer.toString() === p.product.toString());
            if(productTmp === undefined){
                const pp = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
                if(pp === undefined){
                    return;
                }
                const productToPush = {...pp, count: p.count};
                if(p.alt !== undefined){
                    const nlist = p.alt.map(pa => {
                        const altList = [];
                        pa.products.forEach(paPro => {
                            const ppa = productList.find(pl => pl.Artikelnummer? pl.Artikelnummer.toString() === paPro.toString() : false);
                            if(pp === undefined){
                                return;
                            }
                            altList.push(ppa);
                        })
                        pa.products = altList;
                        return pa;
                    });
                    productToPush.productSwitch = nlist;
                }
                uvProducts.push(productToPush);
            }else {
                productTmp.count += p.count;
            }
        });
        uvProducts.forEach(i => uv.installationLocations[0].products.push(i));
        uvProducts.forEach(i => uv.products.push(i));
        generatedProject.floors[0].rooms.push(uv);
        generated_combinations.items[0].subStructure.push(combinations_uv);
    }
console.log('generated switch combinations', generated_combinations)
    return {...projectIn, generatedProject: generatedProject, combinations: generated_combinations}

}
